var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3929 5.21L16.8029 8.02999C16.9929 8.41999 17.5029 8.78999 17.9329 8.86999L20.4829 9.28999C22.1129 9.55999 22.4929 10.74 21.3229 11.92L19.3329 13.91C19.0029 14.24 18.8129 14.89 18.9229 15.36L19.4929 17.82C19.9429 19.76 18.9029 20.52 17.1929 19.5L14.8029 18.08C14.3729 17.82 13.6529 17.82 13.2229 18.08L10.8329 19.5C9.12287 20.51 8.08288 19.76 8.53288 17.82L9.10289 15.36C9.21289 14.9 9.02288 14.25 8.69288 13.91L6.70289 11.92C5.53289 10.75 5.91289 9.56999 7.54289 9.28999L10.0929 8.86999C10.5229 8.79999 11.0329 8.41999 11.2229 8.02999L12.6329 5.21C13.3829 3.68 14.6229 3.68 15.3929 5.21Z",
    stroke: "#30BEAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5H2",
    stroke: "#30BEAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19H2",
    stroke: "#30BEAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12H2",
    stroke: "#30BEAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a8acd638340a8a26911d2288f64cb7f2.svg";
export { ForwardRef as ReactComponent };